// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"12":"842cae8b","272":"bd111f47","449":"bd111f47","795":"bd111f47","822":"bd111f47"}[chunkId] + ".chunk.css";
};